module.exports = __webpack_public_path__ + "static/favicon-96x96.409a94cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon-96x96.png
// module id = 555
// module chunks = 168707334958949